import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchAllLaunches } from '../../features/launchesSlice';
import { Wrapper } from './Stats.styled';
import { BgImage } from '../../components/BgImage/BgImage.styled';
import imageSrc from '../../assets/rocket_fog.jpg';
import MainContainer from '../../components/MainContainer/MainContainer';
import Error from '../../components/Error/Error';
import StatsTable from '../../components/StatsTable.js/StatsTable';
import GaugesStats from '../../components/GaugesStats/GaugesStats';
import ArrowDown from '../../components/ArrowDown/ArrowDown';
import { Helmet } from 'react-helmet-async';

const Stats = ({ windowSize, isMobile }) => {
  const fetchStatus = useSelector((state) => state.allLaunches.status);
  const { data } = useSelector((state) => state.allLaunches);

  const dispatch = useDispatch();

  useEffect(() => {
    if (fetchStatus === 'idle') {
      dispatch(fetchAllLaunches());
    }
  }, [dispatch, fetchStatus]);

  return (
    <>
      <Helmet>
        <link rel='preload' as='image' href={imageSrc} />
      </Helmet>
      {fetchStatus === 'error' && <Error />}
      {data && (
        <MainContainer>
          <BgImage imgSrc={imageSrc} />
          <Wrapper>
            <GaugesStats data={data.docs} />
            {isMobile && <ArrowDown height={windowSize.height} />}
            <StatsTable data={data} isMobile={isMobile} />
          </Wrapper>
        </MainContainer>
      )}
    </>
  );
};

export default Stats;
